import LineIconItem from 'views/chat/components/items/LineIconItem.component';
import useChat from 'hooks/chat/useChat.hook';
import { useChatLines } from 'hooks/chat/useChatLines.hook';

export default function LinesSection() {
  const chat = useChat();
  const { data: lines, loading } = useChatLines();

  return (
    <div className='LinesSection'>
      {lines.map((line, key) => <LineIconItem 
        key={key}
        id={line.id}
        name={line?.name}
        photo={line?.photo}
        isAlert={line?.isAlert}
        onClick={() => {
          chat.dispatch((TYPE) => {
            return {
              type: TYPE.LINE.SELECTED.TYPE,
              payload: line.id
            }
          })
        }}
      />)}
    </div>
  );
}